import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IAPIResponse } from '../enums/types';
import { BaseService } from './base-service';
import { UserService } from './user.service';
import { UtilsService } from "./utils.service";
import { environment } from "../../environments/environment";
import { EModelApiPaths } from '../enums/EModelApiPaths';

@Injectable({
  providedIn: 'root'
})
export class OrderFileUploadService extends BaseService {

  constructor(public override http: HttpClient,
    public override utilsService: UtilsService,
    public override userService: UserService) {
    super(http, userService, utilsService, `${EModelApiPaths.CUSTOM_API_BASE}/${environment.USER_PATH}${EModelApiPaths.FILE_UPLOAD_ORDER}`);
  }

    async fileDownload(body: any) {
        const encryptedData = this.encryptedPayload(body);
        const resp = <any>await this.http.post<IAPIResponse<any>>(environment.GUDIYA_ENTERPRISES_BE_HOST_PORT_SITES + EModelApiPaths.CUSTOM_API_BASE + `/${environment.USER_PATH}` + '/gudiya_printing/download-file', encryptedData, this.userService.getRequestOptions()).toPromise();
        if (this.isEncrypted) return this.utilsService.getDecryptedObject(resp.encryptedData, environment.crypto.passJWT);
        else return resp.data;
    }
}
